import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Tab, Tabs } from 'react-bootstrap';
import R1 from '../images/R1.jpeg';
import R2 from '../images/R2.jpeg';
import R3 from '../images/R3.jpeg';
import R4 from '../images/R4.jpeg';
import R5 from '../images/R5.jpeg';
import R6 from '../images/R6.jpeg';
import R7 from '../images/R7.jpeg';
import R8 from '../images/R8.jpeg';
import R9 from '../images/R9.jpeg';
import R10 from '../images/R10.jpeg';
import R11 from '../images/R11.jpeg';
import R12 from '../images/R12.jpeg';
import R13 from '../images/R13.jpeg';
import R14 from '../images/R14.jpeg';
import V1 from '../videos/V1.mp4';
import V2 from '../videos/V2.mp4';
import V3 from '../videos/V3.mp4';
import V4 from '../videos/V4.mp4';

const Gallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [videoDurations, setVideoDurations] = useState({});

  const handleVideoLoad = (videoId) => {
    const video = document.getElementById(`video-${videoId}`);
    if (video) {
      video.addEventListener('loadedmetadata', () => {
        const duration = Math.floor(video.duration);
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;
        const formattedDuration = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        setVideoDurations(prev => ({
          ...prev,
          [videoId]: formattedDuration
        }));
      });
    }
  };

  const playVideoFullscreen = (videoSrc) => {
    const video = document.createElement('video');
    video.src = videoSrc;
    const isV4 = videoSrc.includes('V4.mp4');
    video.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      object-fit: contain;
      background: black;
      z-index: 9999;
      cursor: pointer;
      transform: ${isV4 ? 'rotate(90deg)' : 'none'};
    `;
    video.controls = true;
    video.autoplay = true;
    video.muted = false;
    
    document.body.appendChild(video);
    
    // Request fullscreen after video is ready
    video.addEventListener('loadedmetadata', () => {
      if (video.requestFullscreen) {
        video.requestFullscreen().catch(err => console.log('Fullscreen request failed:', err));
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    });
    
    // Close on ESC key or click outside controls
    video.addEventListener('click', (e) => {
      // Only close if clicking on the video itself, not the controls
      if (e.target === video) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (document.body.contains(video)) {
          document.body.removeChild(video);
        }
      }
    });
    
    // Remove on exit fullscreen
    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement) {
        if (document.body.contains(video)) {
          document.body.removeChild(video);
        }
      }
    });
  };

  const images = [
    {
      id: 1,
      src: R1,
    },
    {
      id: 2,
      src: R2,
    },
    {
      id: 3,
      src: R3,
    },
    {
      id: 4,
      src: R4,
    },
    {
      id: 5,
      src: R5,
    },
    {
      id: 6,
      src: R6,
    },
    {
      id: 7,
      src: R7,
    },
    {
      id: 8,
      src: R8,
    },
    {
      id: 9,
      src: R9,
    },
    {
      id: 10,
      src: R10,
    },
    {
      id: 11,
      src: R11,
    },
    {
      id: 12,
      src: R12,
    },
    {
      id: 13,
      src: R13,
    },
    {
      id: 14,
      src: R14,
    }
  ];

  const videos = [
    {
      id: 1,
      src: V1,
      duration: '0:45'
    },
    {
      id: 2,
      src: V2,
      duration: '1:23'
    },
    {
      id: 3,
      src: V3,
      duration: '2:15'
    },
    {
      id: 4,
      src: V4,
      duration: '0:17'
    },
  ];

  const openFullscreen = (image) => {
    const img = document.createElement('img');
    img.src = image.src;
    img.alt = image.alt;
    img.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      object-fit: contain;
      background: rgba(0, 0, 0, 0.9);
      z-index: 9999;
      cursor: pointer;
    `;
    
    img.onclick = () => {
      document.body.removeChild(img);
    };
    
    document.body.appendChild(img);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMedia(null);
  };

  

  return (
    <Container fluid className="py-4 py-md-5 px-3 px-md-4">
      <Container>
        <Row className="text-center mb-4 mb-md-5">
          <Col xs={12}>
            <h1 className="display-5 display-md-4 fw-bold mb-3 mb-md-4">Rafting Gallery</h1>
            <p className="lead px-2 px-md-0">
              Explore our collection of thrilling rafting adventures and scenic river journeys
            </p>
          </Col>
        </Row>

        <Tabs
          defaultActiveKey="images"
          id="gallery-tabs"
          className="mb-4 justify-content-center"
        >
          <Tab eventKey="images" title="Photos">
            <Row className="g-3 g-md-4">
              {images.map((image) => (
                <Col key={image.id} xs={12} sm={6} md={4}>
                  <Card className="h-100 shadow-sm gallery-card">
                    <Card.Img
                        variant="top"
                        src={image.src}
                        alt={image.alt}
                        style={{ height: '250px', objectFit: 'cover', cursor: 'pointer' }}
                      />
                    <Card.Body>
                      <Card.Title>{image.title}</Card.Title>
                      <Button
                        variant="primary"
                        size="sm"
                        className="w-100"
                        onClick={() => openFullscreen(image)}
                      >
                        View Full Size
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Tab>
          <Tab eventKey="videos" title="Videos">
            <Row className="g-3 g-md-4">
              {videos.map((video) => (
                <Col key={video.id} xs={12} sm={6} md={4}>
                  <Card className="h-100 shadow-sm gallery-card">
                    <div className="position-relative" style={{ height: '250px', cursor: 'pointer' }} onClick={() => playVideoFullscreen(video.src)}>
                      <video
                        id={`video-${video.id}`}
                        src={video.src}
                        className="w-100 h-100"
                        onLoadedMetadata={() => handleVideoLoad(video.id)}
                        muted
                      />
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <div className="bg-primary bg-opacity-75 rounded-circle p-3 d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                          <i className="fas fa-play text-white fa-2x ms-1"></i>
                        </div>
                      </div>
                      <div className="position-absolute bottom-0 start-0 p-2">
                        <span className="badge bg-dark text-white">
                          {videoDurations[video.id] || video.duration}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </Tab>
        </Tabs>

        {/* Media Modal */}
        <Modal
          show={showModal}
          onHide={closeModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedMedia?.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedMedia && (
              <div className="text-center">
                {videos.some(v => v.id === selectedMedia.id) ? (
                  <div className="ratio ratio-16x9">
                    <video
                      src={selectedMedia.src}
                      controls
                      autoPlay
                      className="w-100 h-100"
                      style={{ 
                        objectFit: 'contain',
                        transform: selectedMedia.id === 4 ? 'rotate(90deg)' : 'none'
                      }}
                    />
                  </div>
                ) : (
                  <img
                    src={selectedMedia.src}
                    alt={selectedMedia.alt}
                    className="img-fluid rounded"
                  />
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>

      <style jsx>{`
        .gallery-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .gallery-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(30, 58, 95, 0.3) !important;
        }
        .gallery-card .card-img {
          transition: transform 0.3s ease;
        }
        .gallery-card:hover .card-img {
          transform: scale(1.05);
        }
        .badge.bg-dark {
          background-color: var(--tertiary-color) !important;
        }
        .play-button {
          position: relative;
          display: inline-block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 15px 0 15px 25px;
          border-color: transparent transparent transparent white;
        }
      `}</style>
      
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />
    </Container>
  );
};

export default Gallery;